export default __webpack_public_path__ + "static/award-2008-05bfabdef69712ec7df5ade618925c51.jpg";